var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[( _vm.$route.fullPath == '/customer-contracts')?_c('router-link',{staticClass:"btn mt-4 float-right new_contract",attrs:{"to":"/customer-contracts/new-contract"}},[_vm._v("New Contract")]):_vm._e(),_c('br'),_c('br'),_c('br'),_c('br'),_c('contract-table',{attrs:{"contracts":_vm.contracts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }